<template>
  <el-container class="view-content">
    <el-header class="header-content">
      <el-row type="flex" justify="space-between" align="middle">
        <statistics :count-list="countList"/>
      </el-row>
    </el-header>
    <el-main class="main-content">
      <vue-table :table-data="tableData">
        <template slot="shopName" slot-scope="{row}">
          <template v-if="row.shop">
            <el-button class="black" type="text" @click="$router.push({path: '/shop/list', query: {shop_id: row.shop_id}})">
              {{row.shop.name}}
            </el-button>
          </template>
          <template v-else>-</template>
        </template>
        <template slot="template" slot-scope="{row}">
          {{formatTemplate(row)}}
        </template>
        <template slot="actionBar">
          <el-table-column align="center" label="操作栏" :resizable="false" width="220">
            <template slot-scope="scope">
              <el-button type="text" @click="downloadFile(scope.row)">下载</el-button>
            </template>
          </el-table-column>
        </template>
      </vue-table>
    </el-main>
    <el-footer class="footer-content">
      <vue-pagination :paging-data="pagingData" @table-reload="getTableList" ref="paging"></vue-pagination>
    </el-footer>
  </el-container>
</template>

<script>
  import {PagingData} from "@mixins"
  import Statistics from "@view/components/Statistics"
  export default {
    name: "shopPortal",
    mixins: [PagingData],
    components: {Statistics},
    data() {
      return {
        // 统计
        countList: [
          {name: "Portal总数", count: 0},
        ],
        // 表格数据
        tableData: {
          tableList: [],
          tableColumn: [
            {label: "所属商家", property: "shopName"},
            {label: "模板名", property: "template"},
            {label: "Portal名称", property: "name"},
            {label: "文件MD5", property: "file_md5"},
            {label: "创建时间", property: "create_at"},
            {label: "修改时间", property: "update_at"},
          ],
        },
      }
    },
    methods: {
      formatTemplate(row) {
        return row?.template?.name || row?.template_info?.name || "-"
      },
      downloadFile(row) {
        window.open(row.file_path, "_parent");
      },
      //获取表格数据
      async getTableList() {
        let nv = {
          page: this.pagingData.currentPage,
          limit: this.pagingData.pageSize,
        };
        let res = await this.$Http.getPortalList(nv);
        if (res?.data) {
          let total = +res.data.total || 0;
          this.pagingData.total = total;
          this.countList[0].count = total;
          this.tableData.tableList = this.getArray(res.data.list);
        }
      },
    },
    created() {
      this.getTableList();
    }
  }
</script>

<style scoped>

</style>
